module.exports = "/_next/static/images/427fa6dfffc6fd36c3b018b6fdb6231b-guy-xs.jpg.webp";